<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M11.998,22.597c-0.203,0-0.401-0.084-0.541-0.231l-9.588-10c-1.951-1.949-2.433-4.928-1.192-7.406
		c1.095-2.189,3.3-3.549,5.754-3.549c1.001,0,1.964,0.228,2.863,0.677c0.619,0.309,1.18,0.714,1.669,1.203l1.036,1.035l1.036-1.035
		c1.211-1.211,2.824-1.878,4.542-1.878c1.718,0,3.33,0.667,4.542,1.878c0.489,0.489,0.894,1.05,1.203,1.668
		c1.238,2.476,0.755,5.456-1.203,7.414l-9.578,9.992C12.399,22.513,12.201,22.597,11.998,22.597z M6.426,2.908
		c-0.528,0-1.053,0.086-1.561,0.255C3.617,3.579,2.606,4.455,2.018,5.631c-0.951,1.899-0.58,4.184,0.922,5.685l9.058,9.447
		l9.047-9.438c1.509-1.51,1.882-3.796,0.933-5.693c-0.237-0.474-0.547-0.904-0.922-1.279c-0.928-0.928-2.165-1.439-3.481-1.439
		s-2.553,0.511-3.481,1.439l-1.566,1.565c-0.142,0.141-0.33,0.219-0.53,0.219c-0.2,0-0.388-0.078-0.53-0.219L9.902,4.352
		C9.527,3.978,9.097,3.668,8.623,3.431C7.929,3.084,7.19,2.908,6.426,2.908z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'love-it',
    },
    name: {
      type: String,
      required: false,
      default: 'LoveIt',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>